import Q from 'q';

import multitracker from 'js/app/multitrackerSingleton';

import type SessionStore from 'bundles/course-sessions/stores/SessionStore';
import type CourseMembershipStore from 'bundles/in-course-stores/stores/CourseMembershipStore';
import type CourseStore from 'bundles/in-course-stores/stores/CourseStore';
import { getCurrentWeek } from 'bundles/in-course-stores/stores/StoreComputationHelpers';
import deadlinesApi from 'bundles/in-course-stores/utils/deadlinesApi';
import handleResponse from 'bundles/naptime/handleResponse';

/**
 * @param {Fluxible.ActionContext} actionContext
 * @param {object} options
 * @param {Array} options.deadlines
 * @return {Promise}
 */
export const receiveDeadlines = function (actionContext: $TSFixMe, { deadlines }: $TSFixMe) {
  const { isEnabled, moduleDeadlines } = deadlines;
  if (isEnabled) {
    actionContext.dispatch('LOAD_COURSE_DEADLINES', { moduleDeadlines });
  } else {
    actionContext.dispatch('DISABLE_DEADLINES');
  }
};

/**
 * @param {Fluxible.ActionContext} actionContext
 * @return {Promise}
 */
export const enableDeadlines = function (actionContext: $TSFixMe) {
  const courseId = actionContext.getStore('CourseStore').getCourseId();
  return deadlinesApi
    .sendStartTime(true, courseId)
    .fail((error) => {
      throw error;
    })
    .then(handleResponse)
    .then(({ elements }) => {
      const { start } = elements[0];
      multitracker.pushV2([
        'open_course_home.welcome.emit.course_deadline_set',
        {
          first_week_due_time: start,
        },
      ]);
      return actionContext.executeAction(receiveDeadlines, {
        deadlines: elements[0],
      });
    });
};

/**
 * @param {Fluxible.ActionContext} actionContext
 * @return {Promise}
 */
export const setDeadlinesIfEligible = function (actionContext: $TSFixMe) {
  const CourseStore: CourseStore = actionContext.getStore('CourseStore');
  const CourseScheduleStore = actionContext.getStore('CourseScheduleStore');
  const ProgressStore = actionContext.getStore('ProgressStore');
  const SessionStore: SessionStore = actionContext.getStore('SessionStore');
  const CourseMembershipStore: CourseMembershipStore = actionContext.getStore('CourseMembershipStore');

  const currentWeek = getCurrentWeek(CourseStore, CourseScheduleStore, ProgressStore);
  const isEnrolled = CourseMembershipStore.isEnrolled();

  if (!SessionStore.isSessionsCourse() && currentWeek === 1 && isEnrolled) {
    return actionContext.executeAction(enableDeadlines, {});
  } else {
    return Q();
  }
};

/**
 * @param {Fluxible.ActionContext} actionContext
 * @param {object} options
 * @param {string} options.userId
 * @return {Promise}
 */
export const loadCourseDeadlines = function (actionContext: $TSFixMe, { userId }: $TSFixMe) {
  const CourseStore: CourseStore = actionContext.getStore('CourseStore');
  const CourseMembershipStore: CourseMembershipStore = actionContext.getStore('CourseMembershipStore');
  const courseId = CourseStore.getCourseId();
  const isEnrolled = CourseMembershipStore.isEnrolled();
  const SessionStore: SessionStore = actionContext.getStore('SessionStore');

  if (!isEnrolled || !userId) {
    return Q();
  }

  if (SessionStore.isSessionsEnabled()) {
    if (SessionStore.isEnrolled()) {
      const session = SessionStore.getSession();
      const deadlines = { moduleDeadlines: session.moduleDeadlines };
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'itemDeadlines' does not exist on type '{... Remove this comment to see the full error message
      deadlines.itemDeadlines = session.itemDeadlines;
      actionContext.dispatch('LOAD_COURSE_DEADLINES', deadlines);
    }

    return Q();
  } else {
    return deadlinesApi
      .getStartTime(courseId)
      .then(handleResponse)
      .then(({ elements }) => {
        const deadlines = elements[0];
        if (deadlines) {
          return actionContext.executeAction(receiveDeadlines, {
            deadlines,
          });
        } else {
          return actionContext.executeAction(setDeadlinesIfEligible, {});
        }
      });
  }
};
